import { useEffect, useState } from 'react';

/** Shared animation clock for decorative product demonstrations. */
export const useLoopingClock = (durationSeconds: number, paused: boolean, tickMs = 100) => {
  const [clock, setClock] = useState(0);

  useEffect(() => {
    if (paused) return;

    const timer = window.setInterval(() => {
      setClock((value) => {
        const next = value + tickMs / 1000;
        return next >= durationSeconds ? 0 : next;
      });
    }, tickMs);

    return () => window.clearInterval(timer);
  }, [durationSeconds, paused, tickMs]);

  return { clock, setClock };
};